// phonesActions.js

export const GET_PHONES = 'GET_PHONES';
export const RESERVE_PHONE = 'RESERVE_PHONE';
